import { render, staticRenderFns } from "./taxi-ride-header.vue?vue&type=template&id=fac0f574&scoped=true"
import script from "./taxi-ride-header.vue?vue&type=script&lang=js"
export * from "./taxi-ride-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac0f574",
  null
  
)

export default component.exports